import { render, staticRenderFns } from "./risk-attendance.view.vue?vue&type=template&id=dbcb9242&scoped=true&"
import script from "./risk-attendance.view.vue?vue&type=script&lang=ts&"
export * from "./risk-attendance.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcb9242",
  null
  
)

export default component.exports